import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import axios from 'axios';
import moment from 'moment';
import config from '../../config';

// components
import TimeProgressView from './TimeProgressView';
import Button, { ButtonKind } from './Button';
// css
import './index.css';

//kaita!
import Calendar from '../calendar';
import CalendarCell from '../calendar/CalendarCell';

//import Navigation from '../Navigation';
//kokomade

const ua = window.navigator.userAgent.toLowerCase();
const isIE = (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1);
const addClassIfIE = classList => {
    return `${classList}${(isIE ? " max-width-100" : "")}`;
}
const toErrPage = (errMsg) => {
    window.location.href = `index.html?msg=${window.btoa(encodeURIComponent(errMsg))}#/error`
}

export default class RecordPage extends Component {
    
    constructor(props) {
        super(props)

        this.state = {
            canStartWorkTime: false,
            canEndWorkTime: false,
            canStartBreakTime: false,
            canEndBreakTime: false,
            canForgetPressTime: true,

            modal: false,
            modalBody: '位置情報を取得中です。<br>※ネットワーク状況により、時間がかかる場合があります',

            calendarKey: 0,//kaita ima
        };
    }

    componentDidMount() {
        this.fetchRecord();
    }

    

    render() {
        console.log('Render calendarKey:', this.state.calendarKey);//kaita! ima


         return (
        <div className="">
            <div className="d-flex flex-column align-items-center scale60">
                <TimeProgressView record={this.state.record} />
                <div className={addClassIfIE('d-flex flex-row justify-content-center flex-wrap window-width')}>
                    <div className={addClassIfIE('d-flex flex-row justify-content-center')}>
                        <Button kind={ButtonKind.START_WORK}
                            disabled={!this.state.canStartWorkTime}
                            onClick={(e) => this.handleClickButton(e, ButtonKind.START_WORK.rawValue)}
                            
                             />
                        <Button kind={ButtonKind.END_WORK}
                            disabled={!this.state.canEndWorkTime}
                            onClick={(e) => this.handleClickButton(e, ButtonKind.END_WORK.rawValue)} 
                            
                             />
                    </div>
                    <div className="d-flex flex-row justify-content-center">
                        <Button kind={ButtonKind.START_BREAK}
                            disabled={!this.state.canStartBreakTime}
                            onClick={(e) => this.handleClickButton(e, ButtonKind.START_BREAK.rawValue)}
                            
                             />
                        <Button kind={ButtonKind.END_BREAK}
                            disabled={!this.state.canEndBreakTime}
                            onClick={(e) => this.handleClickButton(e, ButtonKind.END_BREAK.rawValue)} 
                            
                            />
                    </div>
                </div>

                {/*kaita! */}
                <div> 
                    <br></br>
                    <br></br>
                    <br></br>                  
                </div>
                {/*kokomade */}

                <Button kind={ButtonKind.FORGET_PRESS}
                    disabled={!this.state.canForgetPressTime}
                    onClick={(e) => this.handleClickButton(e, ButtonKind.FORGET_PRESS.rawValue)} 
                    onButtonPress={this.handleButtonPress}//kaita ima
                    />
                <Modal isOpen={this.state.modal}>
                    <ModalBody>
                        {this.state.modalBody.split('<br>').reduce((prev, current) => <span>{prev}<br/>{current}</span>)}
                    </ModalBody>
                </Modal>

            </div>

            {/*kaita! */}
            <div className="scale60-2">
                {/*{ <Calendar user={this.props.user}/>}*/}
                { <Calendar key={this.state.calendarKey} user={this.props.user} />}
            </div>
            {/*kokomade */}

            
        </div>
        
        );
    }

    changeStateByResponse = (record) => {
        if (!record.currentTime && this.state.record && this.state.record.currentTime) {
            record.currentTime = this.state.record.currentTime;
        }
        record.diff = moment(record.currentTime) - moment();

        const canStartWorkTime = !record.startWork || record.endWork;
        let canStartBreakTime = false;
        let canEndBreakTime = false;

        if (!canStartWorkTime && !record.endWork &&
            (record.numberOfBreak === 0 ||
                (record.numberOfBreak > 0 && record.breakTimeItems
                    && record.breakTimeItems[record.numberOfBreak - 1].start
                    && record.breakTimeItems[record.numberOfBreak - 1].end))) {
            canStartBreakTime = true;
        }

        if (!canStartWorkTime && !canStartBreakTime &&
            (record.numberOfBreak > 0 && record.breakTimeItems
                && record.breakTimeItems[record.numberOfBreak - 1].start
                && !record.breakTimeItems[record.numberOfBreak - 1].end)) {
            canEndBreakTime = true;
        }

        const canEndWorkTime = !canStartWorkTime && !canEndBreakTime && !record.endWork;

        // let canForgetPressTime = this.state.canForgetPressTime;
        let canForgetPressTime = true;
        if (canEndWorkTime) {
            // 出勤記録があるが出勤時刻がnull(出勤押し忘れ)
            // かつ
            // まだ休憩の記録がない
            // の場合のみ連続押下禁止でfalseに変更
            // if (record.startWork && !record.startWork.time && record.numberOfBreak === 0) {
            //     canForgetPressTime = false;
            // } else {
            //     canForgetPressTime = true;
            // }
            ButtonKind.FORGET_PRESS.title = '勤務終了押し忘れ';
        } else if (canStartWorkTime) {
            // 出勤押し忘れは常に押下可能
            // canForgetPressTime = true;
            ButtonKind.FORGET_PRESS.title = '勤務開始押し忘れ';
        } else if (canEndBreakTime) {
            // 休憩入り押し忘れはないので常に押下可能
            // kaita!
            ButtonKind.FORGET_PRESS.title = '勤務再開押し忘れ';
        } else {
            ButtonKind.FORGET_PRESS.title = '押し忘れ';
        }

        this.setState({
            record,
            canStartWorkTime,
            canEndWorkTime,
            canStartBreakTime,
            canEndBreakTime,
            canForgetPressTime,

            modal: false,
        });
    }

    
    fetchRecord = async () => {
        let url = `${config.endpoint}/record/latest`;
        let options = {
            headers: {
                'x-api-key': config.apikey,
                'Authorization': `bearer ${this.props.user.token}`,
            }
        };

        return await axios.get(`${url}?_=${Date.now()}`, options)
            .then(response => {
                // console.log('response:', response.data);
                this.changeStateByResponse(response.data);


            }).catch(error => {
                console.error('error', error);
                toErrPage(error.response.data.message)
            });
    }


    handleClickButton = async (event, kind) => {
        event.preventDefault();

        // ボタンがクリックされたときにcalendarKeyを更新
        /*
        await new Promise((resolve) => {
            this.setState(prevState => ({
                calendarKey: prevState.calendarKey + 1
            }), resolve);
        });
    
        console.log('Updated calendarKey:', this.state.calendarKey);

        await new Promise((resolve) => setTimeout(resolve, 10000)); //kaita!

        if (!this.props.user.isMobile || !navigator.geolocation) {
            return this.sendRequest(kind, 0, 0);
        }

        this.state.modal = true;
        */

        if (!this.props.user.isMobile || !navigator.geolocation) {
            await this.sendRequest(kind, 0, 0);
        } else {
            this.setState({ modal: true });//kaita! ima


        const id = setTimeout(() => {
            this.setState(this.state);
        }, 1000);
        
        navigator.geolocation.getCurrentPosition(async (position) => {//(position => {
            clearTimeout(id);
            await this.sendRequest(kind, position.coords.latitude, position.coords.longitude);
            //this.sendRequest(kind, position.coords.latitude, position.coords.longitude);
        }, async (error) => {//error => {
            clearTimeout(id);
            switch (error.code) {
                case 1:
                    toErrPage(`位置情報の取得が許可されていないため、アクセスできません（${this.props.user.userID}）。`)
                    break
                case 2:
                    toErrPage(`位置情報の取得ができないため、アクセスできません（${this.props.user.userID}）。`)
                    break
                default:
                    await this.sendRequest(kind, 0, 0)//this.sendRequest(kind, 0, 0)
                    break;
            }
//getCurrentPositionのオプション削除
//        }, {
//            enableHighAccuracy: true,
        });
    
    }

    const waitTwoSeconds = () => new Promise(resolve => setTimeout(resolve, 1000));
    await waitTwoSeconds();
  
    await new Promise((resolve) => {
        this.setState(prevState => ({
            calendarKey: prevState.calendarKey + 1
        }), resolve);
    });

    /*
    await new Promise((resolve) => {
        this.setState(prevState => ({
            calendarKey: prevState.calendarKey + 1
        }), () => {
            // 1回目の更新が完了した後、2回目の更新を行う
            this.setState(prevState => ({
                anotherKey: prevState.anotherKey + 1
            }), resolve);
        });
    });
    */

    console.log('Updated calendarKey:', this.state.calendarKey);


    };
    
    //kaita ima





/*
    handleClickButton = (event, kind) => {
        // console.log("call handleClickButton()");
        event.preventDefault();

        if (!this.props.user.isMobile || !navigator.geolocation) {
            return this.sendRequest(kind, 0, 0);
        }

        this.state.modal = true;

        const id = setTimeout(() => {
            this.setState(this.state);
        }, 1000);

        navigator.geolocation.getCurrentPosition(position => {
            clearTimeout(id);
            this.sendRequest(kind, position.coords.latitude, position.coords.longitude);
        }, error => {
            clearTimeout(id);
            switch (error.code) {
                case 1:
                    toErrPage(`位置情報の取得が許可されていないため、アクセスできません（${this.props.user.userID}）。`)
                    break
                case 2:
                    toErrPage(`位置情報の取得ができないため、アクセスできません（${this.props.user.userID}）。`)
                    break
                default:
                    this.sendRequest(kind, 0, 0)
                    break;
            }
//getCurrentPositionのオプション削除
//        }, {
//            enableHighAccuracy: true,
        });

    }*/

    sendRequest = async (kind, latitude, longitude) => {
        // console.log("call sendRequest()");

        // if (this.props.user.isMobile && !navigator.geolocation) {
        //     alert('位置情報を取得できない端末のため利用できません。');
        //     return;
        // }

        let modFlg = 0;
        this.state.canForgetPressTime = true;
        if (kind === 'forgetPress') {
            // 押し忘れの場合は現在activeになってるボタンの状態から
            // 条件を分岐していく
            if (this.state.canEndWorkTime) {
                // 退勤押し忘れ
                modFlg = 1;
                kind = 'endWork';
                this.state.canForgetPressTime = false;
            } else if (this.state.canEndBreakTime) {
                // 休憩戻り押し忘れ
                modFlg = 2;
                kind = 'endBreak';
            } else if (this.state.canStartWorkTime) {
                // 出勤押し忘れ
                modFlg = 3;
                kind = 'startWork';
                this.state.canForgetPressTime = false;
            }
        }

        let workDate;
        const now = moment(moment() + this.state.record.diff);
        // if (kind === 'startBreak') {
        //     // window.pressStartBreakTime = now;
        //     window.pressStartBreakTime = now.clone();
        // // } else {
        // //     delete window.pressStartBreakTime;
        // }

        if (kind === 'startWork') {
            workDate = now.format('YYYY-MM-DD');
        } else {
            const startDate = moment(this.state.record.recordDate);
            workDate = startDate.format('YYYY-MM-DD');
        }
        const datetime = now.format('YYYY-MM-DD HH:mm');

        let url = `${config.endpoint}/record`;
        let params = {
            kind,
            workDate,
            datetime,
            latitude,
            longitude,
            modFlg,
            _: now.format(),
        };
        let options = {
            headers: {
                'x-api-key': config.apikey,
                'Authorization': `bearer ${this.props.user.token}`,
            }
        };

        return await axios.post(url, params, options)
            .then(response => {
                if (kind === 'startBreak') {
                    window.pressStartBreakTime = moment(response.data.currentTime);
                } else
                if (kind === 'endBreak') {
                    delete window.pressStartBreakTime
                    document.querySelector('.duration-time').innerText = ''
                }
                console.log('登録しました。');
                // console.log('response', response);
                this.changeStateByResponse(response.data);
            }).catch((error) => {
                console.error('error', error);
                let message
                if (error.response) {
                    message = error.response.data.message || error.message;
                } else {
                    message = error.message;
                }
                toErrPage(message);
            });
    }


};




// WEBPACK FOOTER //
// ./src/components/record/index.js